(function () {
  var root = document.querySelector('.prily-faq');
  if (!root) return;

  var input = root.querySelector('#faqSearch');
  var count = root.querySelector('#faqCount');
  var empty = root.querySelector('#faqEmpty');
  var toc   = root.querySelector('.faq-toc');
  var items = Array.prototype.slice.call(root.querySelectorAll('.faq-group details'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('.faq-group'));
  if (!input || !items.length) return;

  function norm(s) {
    s = String(s);
    if (s.normalize) s = s.normalize('NFKC');
    return s.toLowerCase();
  }

  items.forEach(function (item) {
    item._faqText = norm(item.textContent);
    item._faqOpen = item.hasAttribute('open');
  });

  function clearMarks() {
    var marks = root.querySelectorAll('mark.faq-mark');
    Array.prototype.forEach.call(marks, function (m) {
      var parent = m.parentNode;
      parent.replaceChild(document.createTextNode(m.textContent), m);
      parent.normalize();
    });
  }

  function addMarks(el, terms) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) nodes.push(node);
    }
    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var lower = text.toLowerCase();
      var at = -1;
      terms.forEach(function (t) {
        var i = lower.indexOf(t);
        if (i !== -1 && (at === -1 || i < at)) { at = i; }
      });
      if (at === -1) return;

      var frag = document.createDocumentFragment();
      var rest = text;
      var restLower = lower;
      var guard = 0;
      while (guard++ < 50) {
        var pos = -1, term = null;
        terms.forEach(function (t) {
          var i = restLower.indexOf(t);
          if (i !== -1 && (pos === -1 || i < pos)) { pos = i; term = t; }
        });
        if (pos === -1) break;
        if (pos > 0) frag.appendChild(document.createTextNode(rest.slice(0, pos)));
        var mark = document.createElement('mark');
        mark.className = 'faq-mark';
        mark.textContent = rest.substr(pos, term.length);
        frag.appendChild(mark);
        rest = rest.slice(pos + term.length);
        restLower = rest.toLowerCase();
      }
      if (rest) frag.appendChild(document.createTextNode(rest));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function reset() {
    clearMarks();
    items.forEach(function (item) {
      item.hidden = false;
      if (item._faqOpen) { item.setAttribute('open', ''); }
      else { item.removeAttribute('open'); }
    });
    groups.forEach(function (g) { g.hidden = false; });
    if (toc) toc.hidden = false;
    empty.hidden = true;
    count.textContent = '';
  }

  function run() {
    var raw = input.value.trim();
    if (!raw) { reset(); return; }

    var terms = norm(raw).split(/[\s\u3000]+/).filter(Boolean);
    var rawTerms = raw.toLowerCase().split(/[\s\u3000]+/).filter(Boolean);

    clearMarks();
    var hits = 0;

    items.forEach(function (item) {
      var match = terms.every(function (t) { return item._faqText.indexOf(t) !== -1; });
      item.hidden = !match;
      if (match) {
        hits++;
        item.setAttribute('open', '');
        addMarks(item, rawTerms);
      } else {
        item.removeAttribute('open');
      }
    });

    groups.forEach(function (g) {
      var visible = g.querySelectorAll('details:not([hidden])').length;
      g.hidden = visible === 0;
    });

    if (toc) toc.hidden = true;
    empty.hidden = hits !== 0;
    count.textContent = hits === 0
      ? '該当するご質問が見つかりませんでした'
      : hits + '件のご質問が見つかりました';
  }

  var composing = false;
  var timer = null;

  input.addEventListener('compositionstart', function () { composing = true; });
  input.addEventListener('compositionend', function () { composing = false; schedule(); });
  input.addEventListener('input', function () { if (!composing) schedule(); });
  input.addEventListener('search', function () { schedule(); });

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); run(); }
  });
})();